import React, { useState, useEffect } from "react";
import Banner from "./Banner";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  ClearNotificationAsync,
  getKey,
  getLogin,
  getNotification,
  getNotificationAsync,
  logout,
  resetKey,
  resetResend,
  resetVarified,
} from "../../../features/userSlice";
import MainModal from "../../modals/MainModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import moment from "moment/moment";
import { type } from "@testing-library/user-event/dist/type";

const Header = () => {
  const [isloggedIn, setIsLoggedIn] = useState(false);
  const [modal, setModal] = useState("");
  const [name, setName] = useState("");
  const login = useSelector((state) => state.user.userData, shallowEqual);

  const navRef = React.useRef();
  const key = useSelector(getKey);

  var notification = useSelector(getNotification);
  notification = [...notification].reverse();

  const location = useLocation();
  let { state } = location;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginStatus = useSelector(
    (state) => state.user.loginStatus,
    shallowEqual,
  );
  const backErrors = useSelector((state) => state.user.errors, shallowEqual);
  const forgotApproved = useSelector(
    (state) => state.user.forgotApproved,
    shallowEqual,
  );

  const mytripHandler = (val) => {
    if (val.type === "visa") {
      navigate("/visa", {
        state: { location: "visa" },
        replace: true,
      });
    } else if (val.type === "insurance") {
      navigate("/insurance", {
        state: { location: "insurance" },
        replace: true,
      });
    } else {
      navigate("/mytrip", {
        state: { location: val.type, type: val.process },
        replace: true,
      });
    }

    // switch (type) {
    //   case "hotel_booking":
    //     navigate("/mytrip", {
    //       state: { location: "hotel", type: "confirmed" },
    //       replace: true,
    //     });
    //     break;

    //   case "car_booking":
    //     navigate("/mytrip", {
    //       state: { location: "carrent", type: "confirmed" },
    //       replace: true,
    //     });
    //     break;

    //   default:
    //     navigate("/mytrip", {
    //       state: { location: "hotel", type: "cancelled" },
    //       replace: true,
    //     });
    //     break;
    // }
  };

  const varified = useSelector((state) => state.user.varified, shallowEqual);
  useEffect(() => {
    if (Object.keys(login).length > 0) {
      setName(login?.firstName);
      state = { success: true, logout: false };
      setIsLoggedIn(true);
      dispatch(getNotificationAsync(login.Authorization));
    } else {
      setIsLoggedIn(false);
    }

    setModal("login");
  }, [login]);

  useEffect(() => {
    // if (state !== null) {
    if (state?.success) {
      // if (loginStatus !== "") {
      //   loginStatus
      //     ? successToast("Successfully Logged In!")
      //     : successToast("Successfully Logged out!");
      // }
      setName(login?.firstName);
    } else if (state?.otp === true) {
      // infoToast("OTP Sent To Your Email!");
      // dispatch(resetResend());
    } else {
      //backErrors[0]?.success === false && errorToast(backErrors[0]?.message);
      // setModal("login");
    }
    // }
    window.history.replaceState({}, document.title);
  }, [state, backErrors, loginStatus, login]);

  useEffect(() => {
    if (backErrors[0]?.success === false) {
      if (
        backErrors[0]?.message === "user is not activated,Please varify email."
      ) {
        //setModal("emailVarification");
        // dispatch(resetKey());
        //setShow(true);
      }
    }
  }, [backErrors]);

  useEffect(() => {
    if (varified === false && forgotApproved === false) {
      if (key !== "" && key !== undefined && Object?.keys(key)?.length !== 0) {
        setModal("emailVarification");
        setShow(true);
      }
    }
  }, [varified, key, forgotApproved]);

  const [show, setShow] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    window.onscroll = () => {
      if (window.scrollY >= 10) {
        navRef.current.classList.add("active-bg");
      } else {
        navRef?.current?.classList.remove("active-bg");
      }
      // nav.className = "";
      // else nav.className = "scroll";
    };
  }, [navRef]);

  const logoutUser = () => {
    dispatch(logout());
    setIsClicked(false);
    setShow(false);
    navigate("/", { state: { success: true, logout: true }, replace: true });
  };

  function openNav() {
    document.getElementById("mySidepanel").style.width = "250px";
  }

  function closeNav() {
    document.getElementById("mySidepanel").style.width = "0";
  }

  const clearNotification = () => {
    dispatch(ClearNotificationAsync(login.Authorization));
  };

  return (
    <>
      <header id="navigation_bar" ref={navRef}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg p-0">
                <div className="container p-0">
                  <Link to={"/"} className="navbar-brand p-0" href="index.php">
                    <img src="./assets/images/logo.png" alt="logo-img" />
                  </Link>
                  {/* <button
                    className="navbar-toggler"
                    type="button"
                    // data-bs-toggle="collapse"
                    data-bs-target="#collapsibleNavbar"
                  >
                    <span className="navbar-toggler-icon">
                      <i className="fas fa-bars"></i>
                     
                    </span>
                  </button> */}

                  <button className="openbtn" onClick={() => openNav()}>
                    ☰
                  </button>
                  <div id="collapsibleNavbar">
                    {isloggedIn && (
                      <div className="dropdown notification-dropdown">
                        <button
                          className="dropdown-toggle cmn-btn"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-bell"></i>
                        </button>
                        {notification.length > 0 && (
                          <span className="badge rounded-circle  push-notification">
                            {notification.length}
                          </span>
                        )}
                        <ul
                          className={
                            notification.length === 0
                              ? "dropdown-menu no-notification"
                              : "dropdown-menu"
                          }
                          aria-labelledby="dropdownMenuButton1"
                        >
                          {notification.length > 0 ? (
                            notification.map((val, i) => (
                              <li key={i} onClick={() => mytripHandler(val)}>
                                <div>
                                  <img
                                    src={`assets/images/my-trip/${val.type}-red.svg`}
                                    alt="icon"
                                  />
                                </div>
                                <div>
                                  <p>{val.notification}</p>
                                  <h5>
                                    {moment()
                                      .utc(val.createdAt)
                                      .startOf("hour")
                                      .fromNow()}
                                  </h5>
                                </div>
                              </li>
                            ))
                          ) : (
                            <p className="no-notification">No notification</p>
                          )}
                          {notification.length > 0 && (
                            <li>
                              <span
                                className="dropdown-item"
                                onClick={() => clearNotification()}
                              >
                                Clear all
                              </span>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                    <div id="mySidepanel" className="sidepanel">
                      <Link className="closebtn" onClick={() => closeNav()}>
                        ×
                      </Link>
                      {isloggedIn ? (
                        <div className="dropdown my-profile mobile-side-nav-profile">
                          <button
                            className="dropdown-toggle cmn-btn"
                            type="button"
                            id="dropdownMenuButton9"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <div className="login-icon">
                              <img
                                src="assets/images/login.svg"
                                className="login-icon-img"
                                alt="login-icon"
                              />
                            </div>
                            Hey {name}
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton9"
                          >
                            <li>
                              <Link className="dropdown-item" to={"/profile"}>
                                {" "}
                                <div className="login-icon">
                                  <img
                                    src="assets/images/profile.svg"
                                    alt="profile"
                                  />
                                </div>{" "}
                                <p>My Profile</p>{" "}
                              </Link>
                            </li>
                            <li>
                              <Link className="dropdown-item" to={"/mytrip"}>
                                {" "}
                                <div className="login-icon">
                                  <img
                                    src="assets/images/trip.svg"
                                    alt="trip"
                                  />
                                </div>{" "}
                                <p>My Trip</p>{" "}
                              </Link>
                            </li>
                            <li onClick={() => logoutUser()}>
                              <Link className="dropdown-item">
                                {" "}
                                <div className="login-icon">
                                  <img
                                    src="assets/images/logout.svg"
                                    alt="logout"
                                  />
                                </div>{" "}
                                <p>Logout</p>{" "}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <div
                          onClick={() => {
                            setShow(true);
                            setModal("login");
                          }}
                        >
                          <Link
                            className="cmn-btn d-flex text-decoration-none"
                            data-bs-toggle="modal"
                            data-bs-target="#loginModal"
                          >
                            <div className="login-icon">
                              <img
                                src="assets/images/login.svg"
                                className="login-icon-img"
                                alt="login-icon"
                              />
                            </div>{" "}
                            Login / Sign Up
                          </Link>
                        </div>
                      )}
                    </div>

                    {/* ------mobile-deivce---notification-btn--end-- */}

                    {isloggedIn ? (
                      <div className="dropdown lg-nav-profile-btn my-profile">
                        <button
                          className="dropdown-toggle cmn-btn lg-nav-profile-btn"
                          type="button"
                          id="dropdownMenuButton9"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="login-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M3.195 14.0625C4.14 13.4025 5.0775 12.8962 6.0075 12.5437C6.9375 12.1912 7.935 12.015 9 12.015C10.065 12.015 11.0662 12.1912 12.0037 12.5437C12.9412 12.8962 13.8825 13.4025 14.8275 14.0625C15.4875 13.2525 15.9563 12.435 16.2337 11.61C16.5112 10.785 16.65 9.915 16.65 9C16.65 6.825 15.9187 5.00625 14.4562 3.54375C12.9937 2.08125 11.175 1.35 9 1.35C6.825 1.35 5.00625 2.08125 3.54375 3.54375C2.08125 5.00625 1.35 6.825 1.35 9C1.35 9.915 1.4925 10.785 1.7775 11.61C2.0625 12.435 2.535 13.2525 3.195 14.0625ZM9 9.675C8.13 9.675 7.39875 9.37875 6.80625 8.78625C6.21375 8.19375 5.9175 7.4625 5.9175 6.5925C5.9175 5.7225 6.21375 4.99125 6.80625 4.39875C7.39875 3.80625 8.13 3.51 9 3.51C9.87 3.51 10.6012 3.80625 11.1937 4.39875C11.7863 4.99125 12.0825 5.7225 12.0825 6.5925C12.0825 7.4625 11.7863 8.19375 11.1937 8.78625C10.6012 9.37875 9.87 9.675 9 9.675ZM9 18C7.77 18 6.6075 17.7638 5.5125 17.2912C4.4175 16.8187 3.46125 16.1737 2.64375 15.3562C1.82625 14.5387 1.18125 13.5825 0.70875 12.4875C0.23625 11.3925 0 10.23 0 9C0 7.755 0.23625 6.58875 0.70875 5.50125C1.18125 4.41375 1.82625 3.46125 2.64375 2.64375C3.46125 1.82625 4.4175 1.18125 5.5125 0.70875C6.6075 0.23625 7.77 0 9 0C10.245 0 11.4112 0.23625 12.4987 0.70875C13.5862 1.18125 14.5387 1.82625 15.3562 2.64375C16.1737 3.46125 16.8187 4.41375 17.2912 5.50125C17.7638 6.58875 18 7.755 18 9C18 10.23 17.7638 11.3925 17.2912 12.4875C16.8187 13.5825 16.1737 14.5387 15.3562 15.3562C14.5387 16.1737 13.5862 16.8187 12.4987 17.2912C11.4112 17.7638 10.245 18 9 18ZM9 16.65C9.825 16.65 10.6312 16.53 11.4187 16.29C12.2062 16.05 12.9825 15.63 13.7475 15.03C12.9825 14.49 12.2025 14.0775 11.4075 13.7925C10.6125 13.5075 9.81 13.365 9 13.365C8.19 13.365 7.3875 13.5075 6.5925 13.7925C5.7975 14.0775 5.0175 14.49 4.2525 15.03C5.0175 15.63 5.79375 16.05 6.58125 16.29C7.36875 16.53 8.175 16.65 9 16.65ZM9 8.325C9.51 8.325 9.92625 8.16375 10.2487 7.84125C10.5712 7.51875 10.7325 7.1025 10.7325 6.5925C10.7325 6.0825 10.5712 5.66625 10.2487 5.34375C9.92625 5.02125 9.51 4.86 9 4.86C8.49 4.86 8.07375 5.02125 7.75125 5.34375C7.42875 5.66625 7.2675 6.0825 7.2675 6.5925C7.2675 7.1025 7.42875 7.51875 7.75125 7.84125C8.07375 8.16375 8.49 8.325 9 8.325Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          Hey {name}
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton9"
                        >
                          <li>
                            <Link className="dropdown-item" to={"/profile"}>
                              {" "}
                              <div className="login-icon">
                                <img
                                  src="assets/images/profile.svg"
                                  alt="profile"
                                />
                              </div>{" "}
                              <p>My Profile</p>{" "}
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" to={"/mytrip"}>
                              {" "}
                              <div className="login-icon">
                                <img src="assets/images/trip.svg" alt="trip" />
                              </div>{" "}
                              <p>My Trip</p>{" "}
                            </Link>
                          </li>
                          <li onClick={() => logoutUser()}>
                            <Link
                              to={window.location.pathname}
                              className="dropdown-item"
                            >
                              {" "}
                              <div className="login-icon">
                                <img
                                  src="assets/images/logout.svg"
                                  alt="logout"
                                />
                              </div>{" "}
                              <p>Logout</p>{" "}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setShow(true);
                          setModal("login");
                        }}
                      >
                        <span
                          className="cmn-btn d-flex text-decoration-none"
                          id="outer-login-btn"
                          disabled={true}
                        >
                          <div className="login-icon">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <path
                                  d="M3.195 14.0625C4.14 13.4025 5.0775 12.8962 6.0075 12.5437C6.9375 12.1912 7.935 12.015 9 12.015C10.065 12.015 11.0662 12.1912 12.0037 12.5437C12.9412 12.8962 13.8825 13.4025 14.8275 14.0625C15.4875 13.2525 15.9563 12.435 16.2337 11.61C16.5112 10.785 16.65 9.915 16.65 9C16.65 6.825 15.9187 5.00625 14.4562 3.54375C12.9937 2.08125 11.175 1.35 9 1.35C6.825 1.35 5.00625 2.08125 3.54375 3.54375C2.08125 5.00625 1.35 6.825 1.35 9C1.35 9.915 1.4925 10.785 1.7775 11.61C2.0625 12.435 2.535 13.2525 3.195 14.0625ZM9 9.675C8.13 9.675 7.39875 9.37875 6.80625 8.78625C6.21375 8.19375 5.9175 7.4625 5.9175 6.5925C5.9175 5.7225 6.21375 4.99125 6.80625 4.39875C7.39875 3.80625 8.13 3.51 9 3.51C9.87 3.51 10.6012 3.80625 11.1937 4.39875C11.7863 4.99125 12.0825 5.7225 12.0825 6.5925C12.0825 7.4625 11.7863 8.19375 11.1937 8.78625C10.6012 9.37875 9.87 9.675 9 9.675ZM9 18C7.77 18 6.6075 17.7638 5.5125 17.2912C4.4175 16.8187 3.46125 16.1737 2.64375 15.3562C1.82625 14.5387 1.18125 13.5825 0.70875 12.4875C0.23625 11.3925 0 10.23 0 9C0 7.755 0.23625 6.58875 0.70875 5.50125C1.18125 4.41375 1.82625 3.46125 2.64375 2.64375C3.46125 1.82625 4.4175 1.18125 5.5125 0.70875C6.6075 0.23625 7.77 0 9 0C10.245 0 11.4112 0.23625 12.4987 0.70875C13.5862 1.18125 14.5387 1.82625 15.3562 2.64375C16.1737 3.46125 16.8187 4.41375 17.2912 5.50125C17.7638 6.58875 18 7.755 18 9C18 10.23 17.7638 11.3925 17.2912 12.4875C16.8187 13.5825 16.1737 14.5387 15.3562 15.3562C14.5387 16.1737 13.5862 16.8187 12.4987 17.2912C11.4112 17.7638 10.245 18 9 18ZM9 16.65C9.825 16.65 10.6312 16.53 11.4187 16.29C12.2062 16.05 12.9825 15.63 13.7475 15.03C12.9825 14.49 12.2025 14.0775 11.4075 13.7925C10.6125 13.5075 9.81 13.365 9 13.365C8.19 13.365 7.3875 13.5075 6.5925 13.7925C5.7975 14.0775 5.0175 14.49 4.2525 15.03C5.0175 15.63 5.79375 16.05 6.58125 16.29C7.36875 16.53 8.175 16.65 9 16.65ZM9 8.325C9.51 8.325 9.92625 8.16375 10.2487 7.84125C10.5712 7.51875 10.7325 7.1025 10.7325 6.5925C10.7325 6.0825 10.5712 5.66625 10.2487 5.34375C9.92625 5.02125 9.51 4.86 9 4.86C8.49 4.86 8.07375 5.02125 7.75125 5.34375C7.42875 5.66625 7.2675 6.0825 7.2675 6.5925C7.2675 7.1025 7.42875 7.51875 7.75125 7.84125C8.07375 8.16375 8.49 8.325 9 8.325Z"
                                  fill="currentColor"
                                />
                              </svg>{" "}
                            </span>
                          </div>{" "}
                          Login / Sign Up
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </nav>
            </div>
            <ToastContainer autoClose={2000} />
          </div>
        </div>
      </header>

      {/* -----mobile-side-nav-- */}
      <div id="mySidepanel" className="sidepanel">
        <Link
          className="closebtn"
          to={window.location.pathname}
          onClick={() => closeNav()}
        >
          ×
        </Link>
        {/* -----mobile-side-nav-profile-- */}
        {isloggedIn ? (
          <div className="dropdown my-profile mobile-side-nav-profile">
            <button
              className="dropdown-toggle cmn-btn"
              type="button"
              id="dropdownMenuButton9"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="login-icon">
                <img
                  src="assets/images/login.svg"
                  className="login-icon-img"
                  alt="login-icon"
                />
              </div>
              Hey {name}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton9">
              <li>
                <Link className="dropdown-item" to={"/profile"}>
                  {" "}
                  <div className="login-icon">
                    <img src="assets/images/profile.svg" alt="profile" />
                  </div>{" "}
                  <p>My Profile</p>{" "}
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to={"/mytrip"}>
                  {" "}
                  <div className="login-icon">
                    <img src="assets/images/trip.svg" alt="trip" />
                  </div>{" "}
                  <p>My Trip</p>{" "}
                </Link>
              </li>
              <li onClick={() => logoutUser()}>
                <Link className="dropdown-item" to={"/"}>
                  {" "}
                  <div className="login-icon">
                    <img src="assets/images/logout.svg" alt="logout" />
                  </div>{" "}
                  <p>Logout</p>{" "}
                </Link>
              </li>
            </ul>
          </div>
        ) : (
          <div
            onClick={() => {
              setShow(true);
              setModal("login");
            }}
            className="mobile-side-nav-profile"
          >
            <button
              // to={window.location.pathname}
              className="cmn-btn d-flex text-decoration-none"
              data-bs-toggle="modal"
              data-bs-target="#loginModal"
            >
              <div className="login-icon">
                <img
                  src="assets/images/login.svg"
                  className="login-icon-img"
                  alt="login-icon"
                />
              </div>{" "}
              Login / Sign Up
            </button>
          </div>
        )}
        {/* <Link href="#">About</Link>
        <Link href="#">Services</Link>
        <Link href="#">Clients</Link>
        <Link href="#">Contact</Link> */}
      </div>
      {/* -----mobile-side-nav-end-- */}

      <Banner
        show={show}
        setShow={setShow}
        isClicked={isClicked}
        setIsClicked={setIsClicked}
      />
      {show ? (
        <MainModal
          modal={modal}
          setShow={setShow}
          show={show}
          setModal={setModal}
          extraData={setIsClicked}
        />
      ) : null}
    </>
  );
};

export default Header;
